import React from "react";

const Contacts = () => {
    return <div className = 'body'>наши контакты</div>;
}

export default Contacts;
